import { OrangeTickIcon } from "./icons/orange-tick-icon";
import { DownloadArticlesIcon } from "./icons/download-articles-icon";
import { StayingInformedIcon } from "./icons/staying-informed-icon";
import { CredibleNewsIcon } from "./icons/credible-news-icon";
import { LegacyTrustIcon } from "./icons/legacy-trust-icon";
import { ListenOnTheGoIcon } from "./icons/listen-on-the-go-icon";

export { OrangeTickIcon, DownloadArticlesIcon, StayingInformedIcon, CredibleNewsIcon, LegacyTrustIcon, ListenOnTheGoIcon };

export const hardcodedCards = [
  {
    title: "Multi-Device Access",
    description: "Seamlessly access your E-paper on both web and mobile devices.",
    icon: OrangeTickIcon
  },
  {
    title: "Your Partner in Staying Informed",
    description: "From local updates to global insights, we bring you news you can trust",
    icon: StayingInformedIcon
  },
  {
    title: "Your Daily Dose of Credible News",
    description: "Start every morning with updates you can count on, delivered with care.",
    icon: CredibleNewsIcon
  },
  {
    title: "Downloadable Articles",
    description: "Download unlimited articles in image format for easy sharing and offline reading.",
    icon: DownloadArticlesIcon
  },
  {
    title: "A Legacy of Trust",
    description: "Your Trusted Voice in Journalism for 75 Years and Counting",
    icon: LegacyTrustIcon
  },
  {
    title: "Listen on the Go",
    description: "Too busy to read? Tune in and listen to the news anytime, anywhere!",
    icon: ListenOnTheGoIcon
  }
];
